// extracted by mini-css-extract-plugin
module.exports = {"infobox":"infobox-module--infobox--1Wobh","infobox__title":"infobox-module--infobox__title--14egG","info":"infobox-module--info--3ZrfB","warn":"infobox-module--warn--2-fRX"};